/**
 * @fileOverview This file contains the implementation of the Module component
 * @version 1.0.0
 * @since 1.0.0
 * @author Miguel Ángel Bermea Rodríguez
 */

//#region Imports
import { Box } from '@mui/material';
import Permission from './Permission';
//#endregion

const Module = ({ module, onPermissionChange }) => {
  return (
    <Box sx={{ width: '100%' }}>
      {module.permissions.map((permission) => (
        <Box key={permission.permission_id}>
          <Permission
            permission={permission}
            onPermissionChange={onPermissionChange}
          />
        </Box>
      ))}
    </Box>
  );
};

export default Module;
